import {Box} from "@mui/material"

/**
 * This is a styled <Box> component to use inside <ManageWorkspaceModal>
 * We can't use a theme.js variant because MUI doesn't support the variant prop for MuiBox. We can't put this styling in the Modal component because most children contain 3+ top-level components.
 */
export function ManageModalContainer({children}) {
	return (
		<Box sx={{
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-around",
			height: "100%"
		}}>
			{children}
		</Box>
	)
}